package com.neurobs.ccabserver.translation.components.translatorselection

import com.neurobs.ccab.UserDataRest
import com.neurobs.ccab.db.UserData
import com.neurobs.ccabserver.translation.states.TranslatorStateGenerator
import com.neurobs.react.semanticui.UiButtonFactory._
import slinky.core.FunctionalComponent
import slinky.core.annotations.react
import slinky.core.facade.Hooks.useState
import slinky.core.facade.ReactElement

@react
object OtherUserSelection {
  case class Props(enclosingElement: (ReactElement*) => ReactElement)
  val component = FunctionalComponent[Props] { props =>
    val translatorState = TranslatorStateGenerator.accessState

    val (hidden, setHidden) = useState(true)

    def toggleHidden = () => setHidden(!hidden)

    def selectOtherUser(user: UserDataRest) = translatorState.selectedUserState.setValue(Some(user))
    def clearOtherUser() = translatorState.selectedUserState.setValue(None)

    def UserButton(user: UserDataRest) = {
      def isSelected = translatorState.selectedUserState.value.map(_ == user).getOrElse(false)
      def handleClick = () => if (isSelected) clearOtherUser() else selectOtherUser(user)
      val display = s"${user.email} (${user.id})"
      val modifier = (if (isSelected) "primary" else "") + " mini"
      Button(display, handleClick)(modifier)
    }

    def DisplayButton() = {
      val display = if (hidden) "Show other users" else "Hide other users"
      Button(display, toggleHidden)("green mini")
    }

    def Buttons(users: Seq[UserDataRest]) = {
      if (hidden) Seq(translatorState.selectedUserState.value.map(UserButton(_)).getOrElse(null)) ++ Seq(DisplayButton())
      else users.map(UserButton(_)) ++ Seq(DisplayButton())
    }

    if (!translatorState.validUserData.isSiteAdmin) null
    else {
      translatorState.otherUsersState.ConditionalElements(
        LoadingElement = () => null,
        ErrorElement = _ => null,
        DataElement = userData => props.enclosingElement(Buttons(userData))
      )
    }
  }
}
